import { PROPERTY_PHOTOS } from "./networkConstants";

export function fmt(n) {
  if (!n) return null;
  if (n >= 1000000) return `$${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000)    return `$${(n / 1000).toFixed(0)}K`;
  return `$${n.toLocaleString()}`;
}

export function getPropertyPhoto(type) {
  if (!type) return PROPERTY_PHOTOS.default;
  const t = type.toLowerCase();
  if (t.includes("sfh") || t.includes("single"))                           return PROPERTY_PHOTOS.sfh;
  if (t.includes("multi") || t.includes("apartment"))                      return PROPERTY_PHOTOS.multifamily;
  if (t.includes("commercial") || t.includes("retail") || t.includes("office")) return PROPERTY_PHOTOS.commercial;
  if (t.includes("land") || t.includes("lot"))                             return PROPERTY_PHOTOS.land;
  return PROPERTY_PHOTOS.default;
}

export function relativeTime(dateStr) {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1)  return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24)  return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7)  return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export function computeDealScore(arv, purchase, rehab) {
  if (!arv) return null;
  if (purchase > 0) {
    const equity = arv - purchase - (rehab || 0);
    const pct = (equity / arv) * 100;
    if (pct >= 45) return Math.min(100, Math.round(85 + (pct - 45)));
    if (pct >= 35) return Math.round(75 + (pct - 35));
    if (pct >= 25) return Math.round(60 + (pct - 25) * 1.5);
    return Math.max(0, Math.round(pct * 2));
  } else if (rehab > 0) {
    const ratio = arv / rehab;
    if (ratio >= 7)   return Math.min(100, Math.round(88 + (ratio - 7) * 4));
    if (ratio >= 5)   return Math.round(75 + (ratio - 5) * 6.5);
    if (ratio >= 3.5) return Math.round(60 + (ratio - 3.5) * 10);
    if (ratio >= 2)   return Math.round(35 + (ratio - 2) * 17);
    return Math.round(ratio * 17);
  }
  return null;
}
